import React from 'react';
import { InSyncIcon } from '../icons';

const InSync = () => {
  return <InSyncIcon data-testid="in-sync-icon" />;
};

export default InSync;
